import { Box, styled } from "@mui/material";

export const ChartContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  minWidth: 0,
}));

export const ChartSquare = styled(Box)(() => ({
  position: "relative",
  aspectRatio: "1 / 1",
  height: "95%",
}));

export const ChartCenterOverlay = styled(Box)(() => ({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  pointerEvents: "none",
  textAlign: "center",
}));

export const LegendTable = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
}));

export const LegendRows = styled(Box)(() => ({
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
}));

export const LegendHeaderRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0.5, 1),
  color: theme.palette.text.secondary,
  fontSize: theme.typography.size.xsmall,
  fontWeight: 700,
  textTransform: "uppercase",
}));

export const LegendRow = styled(Box, { shouldForwardProp: (prop) => prop !== "clickable" })<{ clickable?: boolean }>(({ theme, clickable }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.shape.borderRadius,
  cursor: clickable ? "pointer" : "default",

  "&:hover": {
    backgroundColor: clickable ? theme.palette.action.hover : "transparent",
  },
}));

export const LegendSwatch = styled(Box)(() => ({
  height: 10,
  width: 10,
  borderRadius: "50%",
  flexShrink: 0,
}));

export const FooterHint = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(1),
  padding: theme.spacing(0.75, 2),
  borderRadius: 999,
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.secondary,
  fontSize: theme.typography.size.xsmall,
  width: "fit-content",
}));
